import React from 'react'
import { connect } from 'react-redux'
import Partner from '../components/partner'

const mapStateToProps = (state) => ({
  ...state.partner
})

const mapDispatchToProps = dispatch => ({
  onUpdate: payload => dispatch({type: 'PARTNER.UPDATE', payload}),
  onCreateOrganizer: payload => dispatch({type: 'PARTNER.CREATE_ORGANIZER', payload}),
  onUpdateOrganizer: payload => dispatch({type: 'PARTNER.UPDATE_ORGANIZER', payload}),
  onDeleteOrganizer: payload => dispatch({type: 'PARTNER.DELETE_ORGANIZER', payload}),
  onCreateTerm: payload => dispatch({type: 'PARTNER.CREATE_TERM', payload}),
  onUpdateTerm: payload => dispatch({type: 'PARTNER.UPDATE_TERM', payload}),
  onDeleteTerm: payload => dispatch({type: 'PARTNER.DELETE_TERM', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Partner)
